import en from './en';
import type { TranslationSchema } from './en';

const bn: TranslationSchema = {
    ...en,
};

export default bn;
